module.exports = "<button class=btn>&nbsp;</button> ";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/components/cn-distribution-bar/cn-distribution-bar.html
 ** module id = 64
 ** module chunks = 0
 **/